<template>
  <span v-if="icon">
    <div class="badge-bg"></div>
    <icon-hero style="z-index:4;position:relative" v-if="icon == 'hero'" :color="color ? color : 'white'"
      :size="size ? size : '35'">
    </icon-hero>
    <v-icon style="z-index:4;position:relative" v-else :color="color" :size="size ? size : '35'">
      mdi-check-decagram
    </v-icon>
  </span>
</template>

<script>
import IconHero from "@/components/displays/icons/IconHero.vue";

export default {
  props: ["icon", "size", "color"],
  components: {
    IconHero,
  },
};
</script>

<style scoped>
.badge-bg {
  background-color: white;
  height: 65%;
  width: 65%;
  border-radius: 10px;
  margin-top: 0px;
  margin-left: 3px;
  position: absolute;
}
</style>
